
import resetPassword from '~/mixins/common/pages/reset-password'
export default {
    mixins: [resetPassword],
    data() {
        return {
            showPassword: false,
            showOldPassword: false,
            showConfirmPassword: false,
        }
    },
}
